import { CHAT_VIEW_LAST_GROUP_ID_LOCALSTORAGE } from '../constants';
import { TChatGroupId } from '../../../../../../types/rest/IRestChatGroup';

export const setLastChatGroupIdLocalStorage = (
    groupId: TChatGroupId
) => {
    localStorage.setItem(CHAT_VIEW_LAST_GROUP_ID_LOCALSTORAGE, groupId ? JSON.stringify(groupId) : null);
}
